import {Yii} from "libraries/interfaces/Yii";

export const WORDING: { [key: string]: string } = {
    sportSsr: Yii.t('wui-iqba-js', 'Equipement Sportifs'),
};